import { Prisma, SubscriptionInterval, SubscriptionStatus } from "@prisma/client";

export type SubscriptionData = {
  interval: SubscriptionInterval;
  status: SubscriptionStatus;
  currentPeriodEnd: Date;
  cancelAtPeriodEnd: boolean;
  trialEndsAt: Date | null;
};

export const SUBSCRIPTION_SELECT = {
  interval: true,
  status: true,
  currentPeriodEnd: true,
  cancelAtPeriodEnd: true,
  trialEndsAt: true,
} satisfies Prisma.SubscriptionSelect;

export type SubscriptionPeriodRef = {
  userId: number | null;
  companyId: number | null;
  status: SubscriptionStatus;
  currentPeriodStart: Date;
};

export const SUBSCRIPTION_PERIOD_REF_SELECT = {
  userId: true,
  companyId: true,
  status: true,
  currentPeriodStart: true,
} satisfies Prisma.SubscriptionSelect;

export const LAPSED_TRIAL_SELECT = {
  status: true,
  currentPeriodEnd: true,
  stripeSubscriptionId: true,
} satisfies Prisma.SubscriptionSelect;

export const ACTIVE_SUBSCRIPTION_STATUSES: SubscriptionStatus[] = [
  SubscriptionStatus.TRIALING,
  SubscriptionStatus.ACTIVE,
];

export const STRIPE_SUBSCRIPTION_STATUS: Record<string, SubscriptionStatus> = {
  trialing: SubscriptionStatus.TRIALING,
  active: SubscriptionStatus.ACTIVE,
  past_due: SubscriptionStatus.PAST_DUE,
  unpaid: SubscriptionStatus.PAST_DUE,
  incomplete: SubscriptionStatus.PAST_DUE,
  incomplete_expired: SubscriptionStatus.CANCELED,
  canceled: SubscriptionStatus.CANCELED,
  paused: SubscriptionStatus.CANCELED,
};

export const STRIPE_SUBSCRIPTION_INTERVAL: Record<string, SubscriptionInterval> = {
  month: SubscriptionInterval.MONTHLY,
  year: SubscriptionInterval.ANNUAL,
};
